import { defineClientModule, type ModuleRoute } from '@/app/module';
import { registerOfflinePrefetch } from '@/lib/query';
import { registerDrillStream } from './bridge';
import { copy } from './copy';
import { statusQuery } from './queries';
import { pruneSlots } from './store';

/**
 * combine: the onboarding combine. The five drills, the recorder, results, Iso Gauntlet and Draft
 * Night with its idea cards. See docs/MODULE-GUIDE-client.md. Keep this file light: data and lazy
 * imports only.
 */
const routes: ModuleRoute[] = [
  { path: '/combine', screen: () => import('./screens/CombineHub'), tab: 'play' },
  { path: '/combine/start/:level', screen: () => import('./screens/Setup'), tab: 'play' },
  { path: '/combine/run/:id', screen: () => import('./screens/Recorder'), tab: 'play', layout: 'bare' },
  { path: '/combine/run/:id/results', screen: () => import('./screens/Results'), tab: 'play' },
  { path: '/combine/iso/:id', screen: () => import('./screens/Iso'), tab: 'play' },
  { path: '/combine/draft', screen: () => import('./screens/Draft'), tab: 'play', layout: 'bare' },
  { path: '/combine/*', screen: () => import('./screens/CombineMore'), tab: 'play' },
];

export default defineClientModule({
  name: 'combine',
  routes,
  playHubTiles: [
    {
      id: 'combine',
      order: 30,
      title: 'Combine',
      sub: copy.tile,
      to: '/combine',
      color: 'lavender',
      icon: 'whistle',
      size: 'wide',
    },
  ],
  homeCards: [{ id: 'combine', order: 30, component: () => import('./parts/CombineCard') }],
  init() {
    registerDrillStream();
    registerOfflinePrefetch('combine.status', (qc) => qc.prefetchQuery(statusQuery()));
    void pruneSlots(Date.now());
  },
});
